import { EMPTY_VALUE } from '@wix/form-fields';
import { applyAllOverrides } from './all-overrides';
export function clearFieldsWhenHiddenByRule(form, overrides, currentValues, newValues, errors) {
    const fieldCount = (form.fields ?? []).length;
    const clearedTargets = [];
    let currentForm = applyAllOverrides(form, currentValues, overrides);
    for(let i = 0; i < fieldCount; i++){
        const newForm = applyAllOverrides(form, newValues, overrides);
        const newHiddenTargets = findHiddenTargets(newForm);
        const currentHiddenTargets = findHiddenTargets(currentForm);
        const targetsToClear = newHiddenTargets.filter((item)=>!currentHiddenTargets.includes(item));
        if (targetsToClear.length === 0) {
            break;
        }
        currentForm = newForm;
        newValues = clearValues(newValues, targetsToClear);
        clearedTargets.push(...targetsToClear);
    }
    const newErrors = clearErrors(errors, clearedTargets);
    return {
        values: newValues,
        errors: newErrors
    };
}
function clearValues(values, targetsToClear) {
    return Object.keys(values).reduce((result, target)=>{
        if (targetsToClear.includes(target)) {
            result[target] = EMPTY_VALUE;
        } else {
            result[target] = values[target];
        }
        return result;
    }, {});
}
function clearErrors(errors, clearedTargets) {
    return errors.filter((error)=>!clearedTargets.includes(error.errorPath));
}
function findHiddenTargets(form) {
    return (form.fields ?? []).reduce((result, field)=>{
        if (field.hidden && field.target) {
            result.push(field.target);
        }
        return result;
    }, []);
}

//# sourceMappingURL=clear-fields.js.map